import React from "react";
import BtnLoader from "../BtnLoader/BtnLoader";
import SubmitButton from "./SubmitButton";
import { MdQuestionMark } from "react-icons/md";
import Swal from "sweetalert2";

const ExtraService = (props) => {
  const {
    extraServicePrices,
    setExtraServicePrices,
    loaders,
    handleSubmit,
    errorsExtraService,
    setErrorsExtraService,
  } = props;
  const handleInputChangeOne = (index, field, value) => {
    const updatedExtraServicePrices = [...extraServicePrices];
    updatedExtraServicePrices[index][field] = value;
    setExtraServicePrices(updatedExtraServicePrices);
    const updatedErrors = [...errorsExtraService];
    const isAnyFieldFilled = Object.values(
      updatedExtraServicePrices[index]
    ).some((val) => val);
    const newFieldErrors = {
      name: isAnyFieldFilled ? !updatedExtraServicePrices[index].name : false,
      price: isAnyFieldFilled ? !updatedExtraServicePrices[index].price : false,
      type: isAnyFieldFilled ? !updatedExtraServicePrices[index].type : false,
      quantity: isAnyFieldFilled
        ? !updatedExtraServicePrices[index].quantity
        : false,
    };
    updatedErrors[index] = newFieldErrors;
    setErrorsExtraService(updatedErrors);
  };

  const handlePlusClickOne = () => {
    setExtraServicePrices([
      ...extraServicePrices,
      { name: "", price: "", type: "", quantity: "" },
    ]);
    setErrorsExtraService([
      ...errorsExtraService,
      { name: true, price: true, type: true, quantity: true },
    ]);
  };
  const handleMinusClickOne = (index) => {
    if (extraServicePrices.length > 1) {
      const newExtraServicePrices = [...extraServicePrices];
      newExtraServicePrices.splice(index, 1);
      setExtraServicePrices(newExtraServicePrices);

      const newErrors = [...errorsExtraService];
      newErrors.splice(index, 1);
      setErrorsExtraService(newErrors);
    }
  };
  return (
    <>
      {extraServicePrices.map((service, index) => (
        <>
          <div className="md:col-span-6 text-left">
            <label>Name</label>
            <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center">
              <i className="fal fa-tag" />
              <input
                type="text"
                placeholder="Name"
                value={service.name}
                name="name"
                onChange={(e) =>
                  handleInputChangeOne(index, "name", e.target.value)
                }
              />
            </div>
            {errorsExtraService[index]?.name && (
              <p style={{ color: "red" }}>Required</p>
            )}
          </div>

          <div className="md:col-span-6 text-left">
            <label>Price (N)</label>
            <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center">
              <i className="fal fa-dollar-sign" />
              <input
                type="number"
                placeholder="Price"
                value={service.price}
                name="price"
                onChange={(e) =>
                  handleInputChangeOne(index, "price", e.target.value)
                }
              />
            </div>
            {errorsExtraService[index]?.price && (
              <p style={{ color: "red" }}>Required</p>
            )}
          </div>

          <div className="md:col-span-6 text-left">
            <label>Type</label>
            <select
              data-placeholder="Type"
              className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
              value={service.type}
              name="type"
              onChange={(e) =>
                handleInputChangeOne(index, "type", e.target.value)
              }
            >
              <option disabled value="">
                Type
              </option>
              <option value="Single Fee">Single Fee</option>
              <option value="Per Night">Per Night</option>
              <option value="Per Guest">Per Guest</option>
              <option value="Per Night Per Guest">Per Night Per Guest</option>
            </select>
            {errorsExtraService[index]?.type && (
              <p style={{ color: "red" }}>Required</p>
            )}
          </div>

          <div className="md:col-span-6 text-left">
            <label className="inline-flex items-center">
              Quantity Available
              <MdQuestionMark
                onClick={() =>
                  Swal.fire({
                    text: "How many units are available of the Extra Service you are currently entering? For example, if your extra service is a fully stocked refrigerator and you are only willing to stock it one time, enter quantity 1.",
                    icon: "question",
                  })
                }
                style={{
                  color: "#8ec639",
                  cursor: "pointer",
                }}
              />
            </label>
            <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center">
              <i className="fal fa-hashtag"></i>
              <input
                type="number"
                placeholder="Quantity"
                name="quantity"
                value={service.quantity}
                onChange={(e) =>
                  handleInputChangeOne(index, "quantity", e.target.value)
                }
              />
            </div>
            {errorsExtraService[index]?.quantity && (
              <p style={{ color: "red" }}>Required</p>
            )}
          </div>

          <div className="md:col-span-12 flex justify-start items-start">
            {extraServicePrices?.length > 1 && (
              <button
                className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3"
                onClick={() => handleMinusClickOne(index)}
              >
                Remove Service
              </button>
            )}
          </div>
        </>
      ))}

      <div className="md:col-span-12 text-left flex justify-end items-end">
        <button
          onClick={handlePlusClickOne}
          className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3"
        >
          Add Service
        </button>
      </div>

      <div className="md:col-span-12 text-left flex justify-end items-end gap-4">
        <button className="border border-[#3b4249] font-medium bg-[#54c4d9] rounded-md text-white px-8 py-3">
          {loaders ? <BtnLoader /> : <>Save as Draft</>}
        </button>
        <SubmitButton handleSubmit={handleSubmit} loaders={loaders} />
      </div>
    </>
  );
};

export default ExtraService;
